import { useTranslation } from 'react-i18next'
import { useFormikContext } from 'formik'

import { ROUTE_PATH_LIST_AUTH } from '../../../../../constants/route'
import { FieldStackedLabel } from '../../../../Field'
import { FormFieldsContainer } from '../../../../Form'
import { FormikField } from '../../../../Formik'
import { InputField, PasswordInput } from '../../../../Input'
import { LOGIN_FORM_FIELD_HEIGHT } from '../../Login.constants'
import {
  LOGIN_FORM_EMAIL_FIELD_NAME_PASSWORD,
  LOGIN_FORM_EMAIL_FIELD_NAME_USERNAME,
  LOGIN_FORM_EMAIL_MAX_LENGTH_PASSWORD,
  LOGIN_FORM_EMAIL_MAX_LENGTH_USERNAME,
} from '../LoginFormEmail.constants'

import * as styles from './LoginFormEmailFields.module.css'

function LoginFormEmailFields() {
  const { isSubmitting } = useFormikContext()

  const { t } = useTranslation()

  return (
    <FormFieldsContainer className={styles.formFields}>
      <FormikField
        autoFocus
        Component={InputField}
        Field={FieldStackedLabel}
        disabled={isSubmitting}
        height={LOGIN_FORM_FIELD_HEIGHT}
        label={t('Auth.SignInEmailLabelKey')}
        maxLength={LOGIN_FORM_EMAIL_MAX_LENGTH_USERNAME}
        name={LOGIN_FORM_EMAIL_FIELD_NAME_USERNAME}
        placeholder={t('Auth.SignInEmailPlaceholderKey')}
      />
      <FormikField
        Component={PasswordInput}
        Field={FieldStackedLabel}
        disabled={isSubmitting}
        height={LOGIN_FORM_FIELD_HEIGHT}
        label={t('Auth.SignInPasswordLabelKey')}
        link={{
          text: t('Auth.RecoverLinkKey'),
          to: ROUTE_PATH_LIST_AUTH.recoverPassword,
        }}
        maxLength={LOGIN_FORM_EMAIL_MAX_LENGTH_PASSWORD}
        name={LOGIN_FORM_EMAIL_FIELD_NAME_PASSWORD}
        placeholder={t('Auth.SignInPasswordPlaceholderKey')}
      />
    </FormFieldsContainer>
  )
}

export default LoginFormEmailFields
